function normalizeMbFormControlClasses(formControl) {
  if (!formControl) {
    return;
  }

  if (formControl.classList.contains("mb-form-controll--textarea")) {
    formControl.classList.remove("mb-form-controll--textarea");
    formControl.classList.add("mb-form-control--textarea");
  }

  // Cleanup malformed class tokens caused by broken shortcode attributes.
  const invalidClassTokens = Array.from(formControl.classList).filter(
    (className) => className.indexOf("data-validation-message=") === 0
  );
  invalidClassTokens.forEach((className) => {
    formControl.classList.remove(className);
  });
}

export function initMbInputFocus() {
  var inputContainers = document.querySelectorAll(".mb-form-control");
  for (let i = 0; i < inputContainers.length; i++) {
    normalizeMbFormControlClasses(inputContainers[i]);
    var input = inputContainers[i].querySelector("input, textarea, select");
    if (input) {
      if (input.value) {
        inputContainers[i].classList.add("mb-form-control--focused");
      }

      input.addEventListener("focus", function () {
        inputContainers[i].classList.add("mb-form-control--focused");
      });
      input.addEventListener("focusout", function () {
        if (!this.value) {
          inputContainers[i].classList.remove("mb-form-control--focused");
        }
      });
    }
  }
}

export function initMbFormSelect(content = document) {
  const mbFormSelects = content.querySelectorAll(".mb-form-select");
  mbFormSelects.forEach((select) => {
    const selectPlaceholder = select.querySelector(
      ".mb-form-select__placeholder"
    );
    const selectInput = select.querySelector(".mb-form-select__input");
    const selectDropdownWrapper = select.querySelector(
      ".mb-form-select__dropdown-wrapper"
    );
    const selectDropdown = select.querySelector(".mb-form-select__dropdown");
    const selectDropdownClose = select.querySelector(
      ".mb-form-select__dropdown-close"
    );
    const isMultiple = select.classList.contains("mb-form-select--multiple");
    const isButton = select.classList.contains("mb-form-select--button");

    if (!selectPlaceholder || !selectDropdownWrapper || !selectDropdown) {
      return;
    }

    selectPlaceholder.addEventListener("click", function (e) {
      e.stopPropagation();
      toggleFormSelect();
    });

    selectPlaceholder.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault(); // prevent scrolling on Space
        e.stopPropagation();
        toggleFormSelect();
      }
    });

    selectPlaceholder.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        if (
          selectPlaceholder
            .closest(".mb-form-select")
            .classList.contains("mb-form-select--open")
        ) {
          e.preventDefault();
          e.stopPropagation();
          toggleFormSelect();
        }
      }
    });

    function toggleFormSelect() {
      mbFormSelects.forEach((mbFormSelect) => {
        if (mbFormSelect !== select) {
          mbFormSelect.classList.remove("mb-form-select--open");
        }
      });
      select.classList.toggle("mb-form-select--open");

      // make children of dropdown accessible by tab when dropdown is open
      const items = select.querySelectorAll(".mb-form-select__item");
      if (select.classList.contains("mb-form-select--open")) {
        items.forEach((item) => item.setAttribute("tabindex", "0"));
      } else {
        items.forEach((item) => item.setAttribute("tabindex", "-1"));
      }
    }

    selectDropdown.addEventListener("click", function (e) {
      selectDropdown__handleClick(e);
    });
    selectDropdown.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault(); // prevent page scroll on Space
        selectDropdown__handleClick(e);
      }
    });
    selectDropdown.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        const mbFormSelect = selectDropdown.closest(".mb-form-select");
        if (mbFormSelect.classList.contains("mb-form-select--open")) {
          toggleFormSelect();
          mbFormSelect.querySelector(".mb-form-select__placeholder").focus();
        }
      }
    });

    function selectDropdown__handleClick(e) {
      let target = e.target.closest(".mb-form-select__item");
      if (!target.classList.contains("mb-form-select__item")) {
        e.stopPropagation();
        return;
      }
      if (!isMultiple && !isButton) {
        const value = target.innerHTML;
        selectPlaceholder.innerHTML = value;
      }
      const dataValue = target.getAttribute("data-value") || target.innerHTML;
      if (isButton) {
        const dataLink = target.getAttribute("data-link") || target.innerHTML;
        if (dataLink) {
          window.open(dataLink, "_blank");
        }
      } else if (!isMultiple) {
        const oldActiveItems = selectDropdown.querySelectorAll(
          ".mb-form-select__item--active"
        );
        oldActiveItems.forEach((item) => {
          item.classList.remove("mb-form-select__item--active");
        });
        target.classList.add("mb-form-select__item--active");
        if (dataValue && selectInput) {
          selectInput.value = dataValue;
          selectInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      } else {
        target.classList.toggle("mb-form-select__item--active");
        const activeItems = selectDropdown.querySelectorAll(
          ".mb-form-select__item--active"
        );
        const selectedIds = Array.from(activeItems)
          .map((item) => item.getAttribute("data-value") || item.innerHTML)
          .join(",");
        if (selectInput) {
          selectInput.value = selectedIds;
          selectInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      // prevent closing of select when multiple
      if (isMultiple) {
        e.stopPropagation();
      }
    }

    if (selectDropdownClose) {
      selectDropdownClose.addEventListener("click", function (e) {
        e.stopPropagation();
        select.classList.remove("mb-form-select--open");
      });
    }
  });

  if (content === document) {
    document.addEventListener("click", function () {
      document
        .querySelectorAll(".mb-form-select--open")
        .forEach((mbFormSelect) => {
          mbFormSelect.classList.remove("mb-form-select--open");
        });
    });
  }
}
